module.exports = __webpack_public_path__ + "img/6_hillstate.aa802fdb.png";